/** Extracts the AIM envelope message retained on HTTP and envelope errors. */
export function optionApiErrorMessage(
  error: unknown,
  fallback: string,
): string {
  const response = error as {
    error?: { result?: { message?: unknown } };
    result?: { message?: unknown };
  };
  const messages = [
    response?.error?.result?.message,
    response?.result?.message,
    error instanceof Error ? error.message : null,
  ];
  return (
    messages.find(
      (message): message is string =>
        typeof message === 'string' && !!message.trim(),
    ) ?? fallback
  );
}
